export const MAX_VSP_OFFSET = 3_000_000_000
